import styled from '@emotion/styled';

import theme from 'styles/theme';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  background: #f2f2f2;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 16px;
    margin-bottom: 0;
    padding: 16px;
  }
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 4px;
    width: 100%;
  }
`;

export const CheckIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: ${theme.colors.blue};
  color: #fff;
  flex-shrink: 0;

  svg {
    width: 10px;
    height: 10px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Text = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  line-height: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 4px;
    text-align: center;
  }
`;

export const SelectionCount = styled.p`
  margin: 0;
  font-weight: 700;
  color: ${theme.colors.blue};
`;

export const TotalLabel = styled.p`
  margin: 0;
  font-weight: 600;
  color: ${theme.colors.blue};

  @media (max-width: 768px) {
    font-weight: 400;
    color: ${theme.colors.primaryText};
  }
`;

export const TotalPrefixDesktop = styled.span`
  @media (max-width: 768px) {
    display: none;
  }
`;

export const TotalPrefixMobile = styled.span`
  display: none;

  @media (max-width: 768px) {
    display: inline;
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    gap: 12px;
  }
`;

export const ActionButton = styled.button<{ $variant: 'outline' | 'solid' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.2s ease, background 0.2s ease;

  ${({ $variant }) =>
    $variant === 'solid'
      ? `
    border: none;
    background: ${theme.colors.blue};
    color: #fff;
  `
      : `
    border: 1px solid ${theme.colors.blue};
    background: #fff;
    color: ${theme.colors.blue};
  `}

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 40px;
    font-size: 14px;
  }
`;
